import { Handle, Position, NodeProps } from '@xyflow/react';
import { FlowNodeTypeValue } from '../types';
import { getNodeInfo } from '../metadata';

interface AskQuestionNodeData {
  type: FlowNodeTypeValue;
  config: string;
  [key: string]: unknown;
}

/**
 * Nó "Fazer pergunta". Saída normal (inferior) = o contato respondeu.
 * Quando timeoutMinutes > 0, exibe também a saída "sem resposta" (direita), seguida quando
 * o contato não responde no prazo.
 */
export function AskQuestionNode({ data, selected }: NodeProps) {
  const d = data as AskQuestionNodeData;
  const info = getNodeInfo(d.type);
  const { preview, hasTimeout } = parseConfig(d.config);

  return (
    <div
      className="wt-rf-node"
      data-selected={selected ? 'true' : 'false'}
      style={{ borderColor: info.color }}
    >
      <Handle type="target" position={Position.Top} className="wt-rf-port" />
      <div className="wt-rf-node-head" style={{ color: info.color }}>
        <span className="wt-rf-node-dot" style={{ background: info.color }} />
        <span>{info.label}</span>
      </div>
      <div className="wt-rf-node-preview">{preview || info.label}</div>
      {hasTimeout && (
        <div className="wt-rf-waitreply-out wt-rf-waitreply-timeout">
          <span>sem resposta</span>
          <Handle
            type="source"
            position={Position.Right}
            id="timeout"
            className="wt-rf-port wt-rf-port-timeout"
          />
        </div>
      )}
      <Handle type="source" position={Position.Bottom} className="wt-rf-port" />
    </div>
  );
}

function parseConfig(configJson: string): { preview: string; hasTimeout: boolean } {
  try {
    const cfg = JSON.parse(configJson || '{}');
    const q = typeof cfg.question === 'string' ? cfg.question : '';
    const preview = q.length > 40 ? q.slice(0, 40) + '...' : q;
    const m = cfg.timeoutMinutes;
    return { preview, hasTimeout: typeof m === 'number' && m > 0 };
  } catch {
    return { preview: '', hasTimeout: false };
  }
}
